import { useState, useEffect, useContext } from 'react';
import { LoanPhases } from 'scenes/Private/Dashboard/LoanPhases.constanst';
import { CreateTaskResponseContext } from 'scenes/Private/Dashboard/Dashboard';
import { useGetLoanDocByLoan } from 'services/loan/querys';
import { useGetTasksByLoan } from 'services/task/querys';

// Utils
import { calculateLoanProgress } from './utils/calculateLoanProgress';

interface UseLoanPhasesProps {
  loan: any;
  rulesTasksCards: any[];
  handlerSetProgressData: any;
}

export const useLoanPhases = ({
  loan,
  rulesTasksCards,
  handlerSetProgressData
}: UseLoanPhasesProps) => {
  const { value: isCreateTaskResponse }: any = useContext(CreateTaskResponseContext);
  const [phaseSelect, setPhaseSelect] = useState<LoanPhases>();

  // Queries
  const { data: loanDocs, reexecute: getLoanDocs } = useGetLoanDocByLoan({ 
    variables: { loanId: loan._id } 
  });
  const { data: tasks, reexecute: getTasks } = useGetTasksByLoan({ 
    variables: { loanId: loan._id } 
  });

  const phases = calculateLoanProgress(loan, rulesTasksCards, loanDocs || []);

  useEffect(() => {
    const progressData = phases
      .map((item: any) => ({
        key: item.key,
        state: item.state,
        stateName: item.stateName,
      }))
      .filter((item: any) => item.key !== 'pre-approval');

    handlerSetProgressData(progressData);
    getLoanDocs({ requestPolicy: 'network-only' });
    getTasks({ requestPolicy: 'network-only' });
  }, [isCreateTaskResponse]);

  return {
    phases,
    phaseSelect,
    setPhaseSelect,
    tasks,
    loanDocs
  };
};